<template>
    <div>
        <el-dialog :visible.sync="transferState" center :title="$t('m.rejection_reason')" :close-on-click-modal="false"
            :append-to-body="true">
            <el-input class="textinput" type="textarea" resize='none' v-model="rejectReason" :placeholder="$t('m.reasons-for-refusal')" />
            <span slot="footer">
                <el-button @click="transferState = false" size="small">{{ $t('m.cancel') }}</el-button>
                <el-button type="primary" @click="transferEdit" size="small">{{ $t('m.Confirm')
                }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    applyReject
} from '../../../api/anchor/management';
export default {
    data() {
        return {
            transferState: false,//弹框状态
            rejectReason: '',//拒绝理由
            row:{}
        }
    },
    methods: {
        init(row){
            this.transferState = true
            this.row = row
        },
        transferEdit() {
            applyReject({ id: this.row.id, rejectReason: this.rejectReason }).then(({ data }) => {
                this.$emit('affirm')
                this.transferState = false
            }).catch((error) => { })
        }
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/pages/anchor/dialogs/transferAuditDialog.vue